package com.eladfinish.bible.contest.screens.search.suggestions

/**
 * The three pages under the nikud bar, picked by the chips at the bottom of the search screen
 * (and by swiping). The order is the chips' order, start to end.
 */
enum class SuggestionsPage {
    /** The results of the last search, or the autocomplete while typing. */
    RESULTS,

    /** The popular searches of the snapshot's recent window. The default page on entry. */
    HOT_NOW,

    /** The popular searches of all time. */
    MOST_POPULAR,
}
